import { render } from "./FeatureMockup.vue?vue&type=template&id=127f46d0&scoped=true"
import script from "./FeatureMockup.vue?vue&type=script&lang=js"
export * from "./FeatureMockup.vue?vue&type=script&lang=js"

import "./FeatureMockup.vue?vue&type=style&index=0&id=127f46d0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127f46d0"]])

export default __exports__